'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var FooterNavigation = require('./FooterNavigation/FooterNavigation.js');
var canUseWebp = require('../../utils/hooks/canUseWebp.js');
require('./BottomNavigation.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var BottomNavigation = function (props) {
    var isLoggedIn = props.isLoggedIn, activePath = props.activePath, normalMenu = props.normalMenu, loginMenu = props.loginMenu, accountProps = props.accountProps, insuranceLinks = props.insuranceLinks, toolsProps = props.toolsProps, exploreProps = props.exploreProps, NextLink = props.NextLink;
    var LoginNavigation = function () {
        return (React__default['default'].createElement("div", { className: "loginNavigation" }, loginMenu && loginMenu.map(function (menu) {
            return NextLink ?
                React__default['default'].createElement(NextLink, { href: menu.link },
                    React__default['default'].createElement("a", { href: '/#', title: menu.title, className: activePath === menu.link ? 'loginNavigation--buttonActive' : 'loginNavigation--button' },
                        React__default['default'].createElement("div", { className: "\n                  loginNavigation__icon" + (canUseWebp.canUseWebp ? '--webp' : "") + "\n                  loginNavigation__icon" + (canUseWebp.canUseWebp ? '--webp' : "") + "--" + menu.icon + (activePath === menu.link ? '--active' : "") }),
                        React__default['default'].createElement("span", null, menu.title))) :
                React__default['default'].createElement("a", { href: menu.link, title: menu.title, className: activePath === menu.link ? 'loginNavigation--buttonActive' : 'loginNavigation--button' },
                    React__default['default'].createElement("div", { className: "\n            loginNavigation__icon" + (canUseWebp.canUseWebp ? '--webp' : "") + "\n            loginNavigation__icon" + (canUseWebp.canUseWebp ? '--webp' : "") + "--" + menu.icon + (activePath === menu.link ? '--active' : "") }),
                    React__default['default'].createElement("span", null, menu.title));
        })));
    };
    return (isLoggedIn ? React__default['default'].createElement(LoginNavigation, null) :
        React__default['default'].createElement(FooterNavigation, { NextLink: NextLink, menuItems: normalMenu, accountProps: accountProps, insuranceLinks: insuranceLinks, toolsProps: toolsProps, exploreProps: exploreProps }));
};

exports.BottomNavigation = BottomNavigation;
//# sourceMappingURL=BottomNavigation.js.map
